import { getSummaryScanData } from "./get-scan-track-summary.api";
import getCompanyList from "./get-company-list.api";
import getProductList from "./get-product-list.api";
import getBranchList from "./get-branch-list.api";
import getExportScanTrackSummary from "./get-export-scan-track-summary.api";
import getAdditionalInfoFields from "./get-additional-info-fields.api";

const getScanTrackSummaryData = {
  getSummaryData: getSummaryScanData,
  getCompanyList,
  getProductList,
  getBranchList,
  getExportScanTrackSummary,
  getAdditionalInfoFields,
};

export default getScanTrackSummaryData;
